module.exports = "https://trybtryb-legacy.web.app/img/tryb-and-beyond.912f7a24.webp";